import $ from 'jquery';

const toggleThemeInit = () => {
    const $component = $('[data-toggle-theme]');

    if ($component.length) {
        // scroll to top
        $component.click(function (e) {
            e.preventDefault();
            const themeName = $(this).data('toggle-theme');
            $('body').toggleClass(themeName);
        });
    }
};

// doc ready
$(() => {
    toggleThemeInit();
});
